import {Transaction} from './transaction';
import {PageResponse} from '../pageResponse';
import {ReleaseBundle} from './releasebundle';


export interface ProjectBranch {
  id?: string;
  name?: string;
  transactions?: Transaction[];
  creationDate?: Date;
  modifyDate?: Date;
  profilerSnapshotCount?: number;
  profilerDelay?: number;
  releaseBundle?: ReleaseBundle;
}

export class ProjectBranchResponse extends PageResponse {
  content: ProjectBranch[];
}

export class UpdateProjectBranchRequest {
  constructor(public name: string,
              public profilerSnapshotCount: number,
              public profilerDelay: number,
              public releaseBundle: ReleaseBundle) {
  }
}
